import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { useMediaQuery } from '@mui/material';

import ForNonDesktop from '../../components/ForNonDesktop';
import ChatButton from '../../components/HeaderActions/ChatButton';
import CloseButton from '../../components/HeaderActions/CloseButton';
import { selectDiscussion } from '../../db/discussions/selectors';
import { i18nNS } from '../../i18n';
import routes, { DiscussionParams } from '../../pages/routes';
import { useAppSelector } from '../../store/hooks';
import { getUnseenComments } from '../../utils/activities';
import { forDesktop } from '../../utils/media-queries';

const useDiscussionWordCloudHeaderActionsVM = () => {
  const params = useParams<DiscussionParams>();
  const discussion = useAppSelector((state) => selectDiscussion(state, params.discussionShortId));

  const numUnseenComments = discussion ? getUnseenComments(discussion) : 0;

  return { params, numUnseenComments };
};

const DiscussionWordCloudHeaderActions = () => {
  const isDesktop = useMediaQuery(forDesktop);
  const { t } = useTranslation([i18nNS.DISCUSSION]);

  const { params, numUnseenComments } = useDiscussionWordCloudHeaderActionsVM();

  return (
    <>
      <CloseButton
        to={routes.discussion.url(params)}
        edge={isDesktop ? 'end' : undefined}
        aria-label={t('click_to_close_word_cloud', { ns: i18nNS.DISCUSSION })}
      />
      <ForNonDesktop>
        <ChatButton edge="end" numUnseenComments={numUnseenComments} />
      </ForNonDesktop>
    </>
  );
};

export default DiscussionWordCloudHeaderActions;
